import React, { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ContractMgmtRoutes from '../ContractManagement/Routes'

const Home = lazy(() => import('./Home'))
const AddAppointment = lazy(() => import('./Appointment/AddAppointment'))
const DemoForm = lazy(() => import('./DemoForm'))
const NotificationListing = lazy(()=>import('./Notfication/NotificationListing'))

export const HOME_PATH = {
  DEMO_FORM: '/demo/add',
  HOME: '/home',
}
const HomeRoutes: RouteObject[] = [
  {
    path: '',
    element: <Home />,
  },
  {
    path: 'notification-list/:id',
    element: <NotificationListing />,
  },
  {
    path: 'demo/add',
    element: <DemoForm />,
  },
  {
    path: 'add-appointment',
    element: <AddAppointment />,
  },
  // {
  //   path: 'contract-management',
  //   children: [...ContractMgmtRoutes],
  // },
]

export default HomeRoutes
